/**
 * @generated SignedSource<<e6ff10aec323fe9d2eefb238b8821d06>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespPersonalizedItemsCarouselLazy_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespPersonalizedItemsCarousel_viewer">;
  readonly " $fragmentType": "PdpRespPersonalizedItemsCarouselLazy_viewer";
};
export type PdpRespPersonalizedItemsCarouselLazy_viewer$key = {
  readonly " $data"?: PdpRespPersonalizedItemsCarouselLazy_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespPersonalizedItemsCarouselLazy_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isClient"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespPersonalizedItemsCarouselLazy_viewer",
  "selections": [
    {
      "condition": "isClient",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespPersonalizedItemsCarousel_viewer"
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "f6bcd28ef634a52bb73fd5789f17d938";

export default node;
